import React from 'react';
import {PktButton} from "@oslokommune/punkt-react";
import {PLASS_ENDRE_ROUTE} from '../../../routes';
import {goToUrl} from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";
import {Link} from "react-router-dom";

type SøknadCardProps = {
    barnNavn: string;
    søknadsDato: string;
    applicationId: number;
}

const SøknadCard = ({barnNavn, søknadsDato, applicationId}: SøknadCardProps) => {
    return (
        <ApplicationCard title={barnNavn} variant={"gul"}>
            <p>
                Vi mottok søknad om barnehageplass {' '}
                {new Date(søknadsDato).toLocaleDateString('no', {dateStyle: 'long'})}.
            </p>
            <p>
                <div>
                    Tilbud om plass blir sendt til den digitale postkassen din.{' '}
                    <Link className="pkt-link"
                          to="https://www.oslo.kommune.no/barnehage/svar-pa-tilbud-om-plass/#nar-far-du-svar">
                        Se når du kan forvente å få et tilbud
                    </Link>
                </div>
            </p>
            <PktButton
                onClick={() => goToUrl(`${PLASS_ENDRE_ROUTE}/${applicationId}`)}
                size={"small"}
                className={"mt-size-16"}
            >
                Se, endre eller slett
            </PktButton>
        </ApplicationCard>
    );
};

export default SøknadCard;